var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSquareChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 11.3125V8.5C25.375 6.74984 25.375 5.87475 25.0344 5.20628C24.7348 4.61827 24.2567 4.14021 23.6687 3.8406C23.0002 3.5 22.1252 3.5 20.375 3.5H8.5C6.74984 3.5 5.87475 3.5 5.20628 3.8406C4.61827 4.14021 4.14021 4.61827 3.8406 5.20628C3.5 5.87475 3.5 6.74984 3.5 8.5V25.375L9.75 22.25M28.5 28.5L25.0721 26.2147C24.6039 25.9026 24.3698 25.7466 24.1166 25.636C23.8918 25.5379 23.6562 25.4665 23.4147 25.4235C23.1427 25.375 22.8613 25.375 22.2986 25.375H14.75C12.9998 25.375 12.1248 25.375 11.4563 25.0344C10.8683 24.7348 10.3902 24.2567 10.0906 23.6687C9.75 23.0002 9.75 22.1252 9.75 20.375V16.3125C9.75 14.5623 9.75 13.6873 10.0906 13.0188C10.3902 12.4308 10.8683 11.9527 11.4563 11.6531C12.1248 11.3125 12.9998 11.3125 14.75 11.3125H23.5C25.2502 11.3125 26.1252 11.3125 26.7937 11.6531C27.3817 11.9527 27.8598 12.4308 28.1594 13.0188C28.5 13.6873 28.5 14.5623 28.5 16.3125V28.5Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSquareChat);
export default __webpack_public_path__ + "static/media/message-square-chat.66b4263ee3add7bff93dd7e2b48d3544.svg";
export { ForwardRef as ReactComponent };